import type { ImportProgress } from './qobuzPlaylistImportTypes';

export function formatPlaylistImportCompletionLine(progress: ImportProgress): string {
  const checked = Math.max(progress.totalFound, progress.playlistsProcessed);
  const changed = progress.imported + progress.updated;
  if (progress.error) return progress.error;
  if (changed > 0) {
    return `Added ${progress.imported}, updated ${progress.updated}.`;
  }
  return `Up to date — ${checked} checked, 0 changed.`;
}
